import React, {useEffect, useState} from "react";
import {SecondsToMinutes, dateFormatterDDMMMYYY, getImageFromFilesbyKey} from "../../../../_metronic/_helpers";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";

export const SimpleVideoSlide = ({
    preview = false,
    video: {id = "", files = null, title = "", duration = undefined, created_at = "", type_id = 0},
    onclick = () => {},
}) => {
    const [thumbnail, setThumbnail] = useState("");

    useEffect(() => {
        if (files !== null && files !== undefined) {
            const _thumbnail = getImageFromFilesbyKey(files, id, "imgPortrait", type_id);
            setThumbnail(_thumbnail);
        }
    }, [files]);

    return (
        <div key={id} className="simpleSlide" onClick={() => onclick(id)}>
            <div className="dark-overlay_simplevideo text-center">
                {type_id === 1 ? <PlayCircleFilledWhiteOutlinedIcon /> : <DescriptionOutlinedIcon />}
            </div>
            <div
                className={`${
                    preview ? "cropped-preview" : ""
                } overflow-hidden position-absolute w-100 h-100 bg_image_cover w-100`}
                style={{
                    backgroundImage: !preview ? `url(${thumbnail})` : "",
                }}
            />
            <div className="simpleSlide_content">
                <div className="mt-auto w-100">
                    <div className="overflow-hidden d-flex align-items-end h-70px">
                        <span className="simpleSlide_title font-weight-bolder elipsis_3lines">{title}</span>
                    </div>
                    <div className="d-flex w-100 justify-content-between align-items-center mt-5 h-15px simple_video_footer">
                        <span className="simple_video_created_at">{dateFormatterDDMMMYYY(created_at)}</span>
                        <span className="simple_video_duration">
                            {type_id === 1 ? (duration !== undefined ? SecondsToMinutes(duration) + " mins" : null) : null}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
